import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ShowAppVersionBanner } from '@app/core/store/app.actions';
import { slideInOut } from '@app/_animations';
import { utils } from '@app/_utils';
import { Store } from '@ngxs/store';

@Component({
    selector: 'version-bar',
    templateUrl: './version-bar.component.html',
    styleUrls: ['./version-bar.component.scss'],
    animations: [slideInOut],
})
export class VersionBarComponent {
    @Input() reinstallServiceWorker: boolean = false;
    @Input() installationFailed: boolean = false;
    @Output() update: EventEmitter<boolean> = new EventEmitter<boolean>();
    constructor(private store: Store) {}

    close() {
        this.store.dispatch(new ShowAppVersionBanner(false));
    }
    reload() {
        if (this.reinstallServiceWorker) {
            utils.clearCache(false);
            this.update.emit(true);
        } else {
            utils.clearCache(true);
        }
        this.store.dispatch(new ShowAppVersionBanner(false));
    }
}
